import { combineReducers } from "redux";

import { dashboardConstants } from "../actions/dashboard";

function lastEInvoices(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case dashboardConstants.GET_LAST_EINVOICES_SUCCESS:
    return {
      ...defaultState,
      active: payload.active,
      passive: payload.passive
    };
  case dashboardConstants.GET_LAST_EINVOICES_ERROR:
    return null;
  default:
    return defaultState;
  }
}

function isGettingLastEInvoices(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case dashboardConstants.GET_LAST_EINVOICES_START:
    return true;
  case dashboardConstants.GET_LAST_EINVOICES_SUCCESS:
  case dashboardConstants.GET_LAST_EINVOICES_ERROR:
    return false;
  default:
    return defaultState;
  }
}

export const dashboard = combineReducers({
  lastEInvoices,
  isGettingLastEInvoices
});

export default dashboard;
